module.exports = __webpack_public_path__ + "static/media/IMG-2.50d42f2b.jpg";